module.exports = __webpack_public_path__ + "img/icon_vipthumbnail@2x.9130315d.png";